module.exports = __webpack_public_path__ + "img/hover-imgs-item-5.729c0b80.png";